import { Component, ElementRef, Input, OnChanges, Output, SimpleChanges, ViewChild, inject } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators, FormsModule, FormControl, ValidatorFn } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { Observable, Subject, Subscription, firstValueFrom } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { iEntrada, mEntrada, iCatalogos, iAcuerdo } from '../entrada.interface';
import { LoadingService } from '../../loading/loading.service';
import { EntradaService } from '../entrada.service';
import { AlertaService } from '../../alerta/alerta.service';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../app.state';
import { selectCatalogos } from '../../states/catalogos/selector';
import { selectEntrada, selectEntradaEmpresa, selectEntradaTema } from '../../states/entrada/selector';
import { cargaEntrada, cargaEntradaEmpresa, cargaEntradaTipo, cargaEntradaTema, cargaEntradaModoEntrada, cargaEntradaFolio, cargaEntradaPrioridad, cargaEntradaRemitente, cargaEntradaCampos } from '../../states/entrada/actions';
import { Editor, NgxEditorModule, Toolbar, Validators as Validatorsngx  } from "ngx-editor";
import { selectAcuerdo } from '../../states/acuerdo/selector';
import { AddRemitenteComponent } from '../../catalogos/remitentes-destinatarios/add-remitente/add-remitente.component';
import { showHideCatalogo } from '../../states/admon-catalogos/actions';
import { RemitenteService } from '../../services/catalogos/remitente/remitente.service';
import { TreemapComponent } from '../../treemap/treemap.component';
import { ActivatedRoute } from '@angular/router';
import { cargaCatalogos, cargaRemitente } from '../../states/catalogos/actions';
import { iUsuario } from '../../usuario/usuario.interface';
import { selectUsuario } from '../../states/usuario/selector';
import { toolbarEditor } from '../../utils';
import moment from 'moment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/************************************************************************************************************/
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { dE } from '@fullcalendar/core/internal-common';
/************************************************************************************************************/

@Component({
  selector: 'app-add-edit-entrada',
  standalone: true,
  imports: [MatToolbarModule, MatButtonModule, MatIconModule, MatTabsModule, ReactiveFormsModule, MatInputModule, 
            MatFormFieldModule, FormsModule, MatRadioModule, MatDatepickerModule, MatSelectModule, MatAutocompleteModule,
            AsyncPipe, MatChipsModule, EditorModule, NgxEditorModule, CommonModule, AddRemitenteComponent,
            TreemapComponent],
  providers: [
    //provideNativeDateAdapter(),
    provideMomentDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX'},
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
  ],
  templateUrl: './add-edit-entrada.component.html',
  styleUrl: './add-edit-entrada.component.css'
})
export class AddEditEntradaComponent {
  @ViewChild('inputRemitente') input!: ElementRef<HTMLInputElement>;
  private active = inject(ActivatedRoute);
  private loadingService = inject(LoadingService);
  private entradaService = inject(EntradaService);
  private alertaService = inject(AlertaService);
  private remitenteService = inject(RemitenteService);
  private formBuilder: FormBuilder = inject(FormBuilder);
  private readonly store: Store<AppState> = inject(Store);
  private readonly stateCatalogo: any = this.store.pipe(select(selectCatalogos));
  private readonly stateEntrada: any = this.store.pipe(select(selectEntrada));
  private readonly stateAcuerdo: any = this.store.pipe(select(selectAcuerdo));
  private readonly stateUsuario: any = this.store.pipe(select(selectUsuario));
  private idEntrada = this.active.snapshot.params['id'];
  private idTema = this.active.snapshot.params['tema'];
  private subscriptions = new Subscription();
  private sanitizer = inject(DomSanitizer);

  @Input() listenToFather!: Observable<boolean>;
  @Output() sendToFather: Subject<any> = new Subject();

  public oEntrada: iEntrada;
  public oCatalogos: iCatalogos;
  public oAcuerdo: iAcuerdo;
  public oUsuario: iUsuario;
  public formEntrada!: FormGroup;
  public catTema:any = [];
  public catTipo:any = [];
  public catModoEntrada:any = [];
  public catPrioridad:any = [];
  public catEmpresa:any = [];
  public catRemitente:any = [];
  public filterRemitente:any =[];
  public deshabilitado: boolean = false;
  
  campos: any[] = [];
  lista_enviado_a: any[] = [];
  lista_delegado: any[] = [];
  lista_copia: any[] = [];
  filterEnviadoA: Observable<any[]> | undefined;
  filterDelegado: Observable<any[]> | undefined;
  filterConCopiaA: Observable<any[]> | undefined;
  today: Date = new Date();
  no_aplica: any = {
    id: "NA",
    nombre : "No Aplica",
    apellido: "",
    mail: "...",
    activo: true,
    mostrar :true
  }

  public editor!: Editor;
  public toolbar: Toolbar = toolbarEditor;
  public safeHtml: SafeHtml;

  constructor() {
    this.loadingService.showFull();
    this.loadingService.show();
    this.oEntrada = structuredClone(this.stateEntrada.state().entrada);
    this.oAcuerdo = structuredClone(this.stateAcuerdo.state().acuerdo);
    this.oUsuario = structuredClone(this.stateUsuario.state().usuario);
    
    this.oCatalogos =     this.stateCatalogo.state().catalogos;
    this.catTema =        this.oCatalogos.catTema;
    this.catTipo =        this.oCatalogos.catTipo;
    this.catModoEntrada = this.oCatalogos.catModoEntrada;
    this.catPrioridad =   this.oCatalogos.catPrioridad;
    this.catEmpresa =     this.oCatalogos.catEmpresa;
    this.catRemitente =   this.oCatalogos.catRemitente;
    this.editor = new Editor();
    
    //this.lista_enviado_a = this.catRemitente.filter((item:any) =>  this.oEntrada.remitente_enviado.includes(item.id));
    //this.lista_delegado = this.catRemitente.filter((item:any) => this.oEntrada.delegado.includes(item.id));
    //this.lista_copia = this.catRemitente.filter((item:any) =>  this.oEntrada.copia.includes(item.id));
    
    this.lista_enviado_a = this.oEntrada.remitente_enviado.map((id:any) => {
      let remitente = this.catRemitente.filter((item:any) => item.id == id);
      if(remitente.length == 0) { return this.fnRemitenteEliminado(id); }
      return remitente[0];
    });
    
    this.lista_delegado = this.oEntrada.delegado.map((id:any) => {
      if(id == "NA") return this.no_aplica;
      let remitente = this.catRemitente.filter((item:any) => item.id == id);
      if(remitente.length == 0) { return this.fnRemitenteEliminado(id); }
      return remitente[0];  
    });

    this.lista_copia = this.oEntrada.copia.map((id:any) => {
      if(id == "NA") return this.no_aplica;
      let remitente = this.catRemitente.filter((item:any) => item.id == id);
      if(remitente.length == 0) { return this.fnRemitenteEliminado(id); }
      return remitente[0];
    });

    let fechaInicio = (this.oEntrada.fechaInicio)?moment(this.oEntrada.fechaInicio).toDate():'';
    let fechaFin = (this.oEntrada.fechaFin)?moment(this.oEntrada.fechaFin).toDate():'';

    this.formEntrada = this.formBuilder.group({
      tipoCorreo: [`${this.oEntrada.tipoCorreo}`],
      fechaInicio: [fechaInicio, [Validators.required]],
      fechaFin: [fechaFin, [Validators.required]],
      asunto: [this.oEntrada.asunto, [Validators.required]],
      remitente: [this.oEntrada.remitente, [Validators.required]],
      remitente_enviado: ['', [this.validateEnvidadoDelegado.bind(this)]],
      //delegado: ['', [this.validateDelegado.bind(this)]],
      copia: ['', []],
      tema: [this.oEntrada.tema, [Validators.required]],
      tipo: [this.oEntrada.tipo, [Validators.required, this.validateTipo.bind(this)]],
      modo_entrada: [this.oEntrada.modo_entrada, [Validators.required, this.validateModoEntrada.bind(this)]],
      prioridad: [this.oEntrada.prioridad, [Validators.required, this.validatePrioridad.bind(this)]],
      empresa: [this.oEntrada.empresa, [Validators.required, this.validateEmpresa.bind(this)]],
      empresa_descripcion: [this.oEntrada.empresa_descripcion, [Validators.required]],
      descripcion: [this.oEntrada.descripcion_html? this.oEntrada.descripcion_html : this.oEntrada.descripcion, [Validators.required]]
    });

    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.oEntrada.descripcion_html);

    /////////////////////////////// FILTROS AUTOCOMPLETE ///////////////////////////////
    this.filterEnviadoA = this.formEntrada.get('remitente_enviado')?.valueChanges.pipe(
      startWith(''),
      map(value => this.filter(value || ''))
    );
    /*this.filterDelegado = this.formEntrada.get('delegado')?.valueChanges.pipe(
      startWith(''),
      map(value => this.filter(value || ''))
    );*/
    this.filterConCopiaA = this.formEntrada.get('copia')?.valueChanges.pipe(
      startWith(''),
      map(value => this.filterCopiaNoAplica(value || ''))
    );
    ////////////////////////////////////////////////////////////////////////////////////

    ///////////////////////////// ONCHANGE BUSINESS RULES //////////////////////////////
    this.formEntrada.get('tipoCorreo')?.valueChanges.subscribe(value => {
      this.businessRules('tipoCorreo', value);
    });
    this.formEntrada.get('fechaInicio')?.valueChanges.subscribe(value => {
      value =  moment(value).toDate();
      this.businessRules('fechaInicio', value);
    });
    this.formEntrada.get('remitente')?.valueChanges.subscribe(value => {
      this.businessRules('remitente', value);
    });
    this.formEntrada.get('tema')?.valueChanges.subscribe(value => {
      this.businessRules('tema', value);
    });
    this.formEntrada.get('tipo')?.valueChanges.subscribe(value => {
      this.businessRules('tipo', value);
    });
    this.formEntrada.get('modo_entrada')?.valueChanges.subscribe(value => {
      this.businessRules('modo_entrada', value);
    });
    this.formEntrada.get('prioridad')?.valueChanges.subscribe(value => {
      this.businessRules('prioridad', value);
    });
    this.formEntrada.get('empresa')?.valueChanges.subscribe(value => {
      this.businessRules('empresa', value);
    });
    this.formEntrada.get('empresa_descripcion')?.valueChanges.subscribe(value => {
      this.businessRules('empresa_descripcion', value);
    });
    this.formEntrada.get('descripcion')?.valueChanges.subscribe(value => {
      this.businessRules('descripcion', value);
    });
    ////////////////////////////////////////////////////////////////////////////////////

    if(this.idEntrada != 'add') {
      this.formEntrada.disable({emitEvent: false});
      this.deshabilitado = true;
    }

    //FIX PARA REMITENTE SIN INFROMACION Y CON SOBRE CERRADO
    if(this.oEntrada.remitente !== "" && this.oEntrada.remitente_descripcion === "") {
      try {
        let oRemitente = this.catRemitente.filter((item:any) => { return item.id == this.oEntrada.remitente });
        if(oRemitente.length == 1) {
          oRemitente = oRemitente[0];
          this.store.dispatch(cargaEntradaRemitente({ oRemitente }));
        } else {
          this.alertaService.open("Entrada con remitente incompleto", "Elimine y seleccione nuevamente al remitente.");  
        }  
      } catch (error) {
        this.alertaService.open("Entrada con remitente incompleto", "Elimine y seleccione nuevamente al remitente.");
      }
    }

    this.loadingService.hide();
  }
  
  async ngOnInit() {
    const busqueda = this.active.snapshot.queryParamMap.get('campo');
    this.campos = (busqueda?.split('|'))? busqueda?.split('|') : [];
    
    this.subscriptions.add(
      this.store.select(selectEntrada).subscribe((oEntrada) => {
        this.oEntrada = structuredClone(oEntrada);
      })
    );

    this.subscriptions.add(
      this.store.select(selectEntradaTema).subscribe((tema) => {
        this.formEntrada.get('tema')?.setValue(tema, { emitEvent: false });
      })
    );
    
    this.formEntrada.statusChanges.subscribe((status:any) => {
      if(status == 'VALID') {
        const formData = this.formEntrada.value;
        this.store.dispatch(cargaEntradaCampos({ oData: {
          'tipoCorreo':  formData.tipoCorreo,
          'fechaInicio': moment(formData.fechaInicio).toDate(),
          'fechaFin': moment(formData.fechaFin).toDate(),
          'asunto': formData.asunto,
          'descripcion': this.fnHtmltoText(formData.descripcion),
          'descripcion_html': formData.descripcion
        }}));
      }
      this.validacionFormulario();
    });

    this.subscriptions.add(
      this.listenToFather.subscribe((oData: any) => {
        if(oData.accion == 'disabled') {
          this.deshabilitado = oData.deshabilitado;
          if(oData.deshabilitado) {
            this.formEntrada.disable({emitEvent: false});
          } else {
            this.formEntrada.enable({emitEvent: false});
            this.disabledDelegadoCopy();
          } 
          
          this.validacionFormulario();
          if(this.oEntrada.tipoCorreo == 2){
            this.formEntrada.get('remitente')?.disable();
          }
        }
      })
    );

    this.validacionFormulario();
  }

  ngAfterViewInit() {
    console.log('La vista del componente y sus hijos han sido inicializados. 1');
    this.loadingService.hideFull();
  }

  fnHtmltoText(html: string) {
    try {
      let oParser = new DOMParser();
      let oDOM = oParser.parseFromString(html, "text/html");
      return oDOM.body.innerText;  
    } catch (error) {
      debugger;
      console.log(error);
      return html.replace(/<[^>]*>/g, '');
    }
  }

  validacionFormulario() {
    Promise.resolve().then( () => {
      const status = this.formEntrada.status;
      this.sendToFather.next({formEntrada: status});
    });
  }
  
  businessRules(type:string, value:any): void {
    if(type == 'tipoCorreo') {
      this.store.dispatch(cargaEntradaCampos({ oData: {'tipoCorreo': value} }));
      if(value == 2) {
        this.formEntrada.get('remitente')?.disable({ emitEvent: false });
        this.formEntrada.get('remitente')?.setValue('-Kd1EX0gNjABLH0Yj0fN');
        this.hideRemitente();
      } else {
        this.formEntrada.get('remitente')?.enable({ emitEvent: false });
      }
    }

    if(type == 'fechaInicio') {
      this.store.dispatch(cargaEntradaCampos({ oData: {'fechaInicio': value} }));
      this.businessRules('modo_entrada', this.formEntrada.get('modo_entrada')?.value); 
    }

    if(type == 'remitente') {
      let oRemitente = { 'id': '', 'nombre': '', 'apellido': '', 'mail': '', 'vip': false };
      if(value) {
        oRemitente = this.catRemitente.filter((item:any) => { return item.id == value })[0];
        this.changeList(oRemitente.id);
      }
      this.store.dispatch(cargaEntradaRemitente({ oRemitente }));
      this.businessRules('modo_entrada', this.formEntrada.get('modo_entrada')?.value);
    }

    if(type == 'tema') {
      const oTema = this.catTema.filter((item:any) => { return item.id == value })[0];
      this.store.dispatch(cargaEntradaTema({ oTema }));
    }

    if(type == 'tipo') {
      const oTipo = this.catTipo.filter((item:any) => { return item.id == value })[0];
      this.store.dispatch(cargaEntradaTipo({ oTipo }));
    }

    if(type == 'modo_entrada' && value !== null && value !== '' && value !== undefined) {
      const oModoEntrada = this.catModoEntrada.filter((item:any) => { return item.id == value })[0];
      this.store.dispatch(cargaEntradaModoEntrada({ oModoEntrada }));
      
      if(oModoEntrada.descripcion.includes("Sobre Cerrado")) {
        let fecha = this.formEntrada.get('fechaInicio')?.value;
        let remitente = this.formEntrada.get('remitente')?.value;
        
        if(fecha && remitente) {
          if(this.oEntrada.folio == "" || this.idEntrada == "add") {
            this.loadingService.show();

            fecha = moment(fecha).format('YYYYMMDD');
            remitente =  this.catRemitente.filter((item:any) => { return item.id == remitente })[0];
            let nombre = `${remitente.nombre} ${remitente.apellido}`;
            let email = remitente.mail;

            this.subscriptions.add(
              this.entradaService.generarFolio(email, nombre, fecha).subscribe({
                next: (oFolio:any) => {
                  this.loadingService.hide();
                  if(oFolio.folio && parseInt(oFolio.folio.substr(10,4)) < 1000) {
                    this.store.dispatch(cargaEntradaFolio({ oFolio }));
                  } else {
                    this.alertaService.open("Error Sobre Cerrado", "Se ha llegado al límite de sobres cerrados por día. Favor de registrar con una fecha posterior.");
                  }
                },
                error: (error) => {
                  this.loadingService.hide();
                  this.alertaService.open("Error Sobre Cerrado", JSON.stringify(error));
                }
              })
            );
          }
        } else {
          this.alertaService.open('Modo de entrada', 'Para seleccionar sobre cerrado es necesario elegir un Remitente y una Fecha Inicio.');
          this.store.dispatch(cargaEntradaFolio({ oFolio: { folio:'' } }));
        }
      } else {
        this.store.dispatch(cargaEntradaFolio({ oFolio: { folio:'' } }));
      }
    }

    if(type == 'prioridad') {
      const oPrioridad = this.catPrioridad.filter((item:any) => { return item.id == value })[0];
      this.store.dispatch(cargaEntradaPrioridad({ oPrioridad }));
    }

    if(type == 'empresa') {
      if(this.oAcuerdo.numeroEntradasTema == 1 && this.oEntrada.empresa != value) {
        this.alertaService.open("Importante", "El tema debe contener al menos una entrada. Seleccione la acción ‘Quitar tema’ desde la tabla de despacho, si desea desasociar la entrada y eliminar el tema.");
        this.formEntrada.get('empresa')?.setValue(this.oEntrada.empresa, { emitEvent: false });
        return;
      }
      
      if(value == 'otro') {
        this.formEntrada.get('empresa_descripcion')?.setValue('');
        return;
      }
      
      const oEmpresa = this.catEmpresa.filter((item:any) => { return item.id == value })[0];
      this.store.dispatch(cargaEntradaEmpresa({ oEmpresa }));
      this.formEntrada.get('empresa_descripcion')?.setValue(oEmpresa.descripcion, { emitEvent: false })
    }

    if(type == 'empresa_descripcion') {
      const oEmpresa = {id:'otro', descripcion: value};
      this.store.dispatch(cargaEntradaEmpresa({ oEmpresa }));
    }

    if(type == 'descripcion') {
      const onlyText = value.replace(/<[^>]*>/g, '');
      if(onlyText.length == 0)
        this.formEntrada.get('descripcion')?.setValue('', {emitEvent: false});
    }
  }

  filter(search: string) {
    search = search.toLowerCase();
    let results = this.catRemitente.filter((item: any) => { 
      const fullName = `${item.nombre} ${item.apellido}`;
      return (item.activo && (fullName.toLowerCase().includes(search) || item.mail.toLowerCase().includes(search)))
    });

    const idRemitente = this.formEntrada.get('remitente')?.value;
    if(idRemitente != '-Kd1EX0gNjABLH0Yj0fN' && this.lista_delegado.length == 0 && search.length > 0 && "no aplica".includes(search)) {
        results.unshift(this.no_aplica);
    }
    return results;
  }

  filterCopiaNoAplica(search: string) {
    search = search.toLowerCase();
    let results = this.catRemitente.filter((item: any) => { 
      const fullName = `${item.nombre} ${item.apellido}`;
      return (item.activo && (fullName.toLowerCase().includes(search) || item.mail.toLowerCase().includes(search)))
    });
    if(this.lista_copia.length == 0 && search.length > 0 && "no aplica".includes(search)) {
      results.unshift(this.no_aplica);
    }
    return results;
  }

  disabledDelegadoCopy() {
    const delegado = (this.lista_delegado.length == 1 && this.lista_delegado[0].id == "NA");
    const copy = (this.lista_copia.length == 1 && this.lista_copia[0].id == "NA");
    
    if(delegado) {
      this.formEntrada.get('remitente_enviado')?.disable({emitEvent: false});
    } else {
      this.formEntrada.get('remitente_enviado')?.enable({emitEvent: false});
    } 
  
    if(copy) {
      this.formEntrada.get('copia')?.disable({emitEvent: false});
    } else {
      this.formEntrada.get('copia')?.enable({emitEvent: false});
    }
  }

  selectedFilter(): void {
    //let filterValue = this.input.nativeElement.value;
    //this.filterRemitente = this.filter(filterValue);
    
    let search = this.input.nativeElement.value .toLowerCase();
    this.filterRemitente = this.catRemitente.filter((item: any) => { 
      const fullName = `${item.nombre} ${item.apellido}`;
      return (item.activo && (fullName.toLowerCase().includes(search) || item.mail.toLowerCase().includes(search)))
    });
  }

  selectedOption(type: string, event: any) {
    const selectedValue = event.option.value;
    this.addList(type, selectedValue);
  }

  selectedDisplayRemitente(id:any) {
    if(id == '') return '';

    const item = this.catRemitente.filter((item: any) => { return item.id === id });
    if(item.length == 0)
      return '';

    return `${item[0].nombre} ${item[0].apellido}`;
  }

  selectedDisplay(item:any) {
    return '';
  }

  changeList(id: string) {
    //ACTIVAMOS ENVIADO A
    if(id == '-Kd1EX0gNjABLH0Yj0fN') {
      if(this.lista_delegado.length == 1 && this.lista_delegado[0].id == "NA") {
        this.lista_delegado = [];
      }
      if(this.oEntrada.remitente_enviado.length == 0 && this.oEntrada.delegado.length > 0) {
        this.lista_enviado_a = structuredClone(this.lista_delegado);
        this.lista_delegado = [];
        this.actualizarLista();
      }
    } else {
      if(this.oEntrada.delegado.length == 0 || this.oEntrada.remitente_enviado.length > 0) {
        this.lista_delegado = structuredClone(this.lista_enviado_a);
        this.lista_enviado_a = [];
        this.actualizarLista();
      }
    }
  }

  addList(type: string, id: string): void {    
    if(type == 'enviado_a' && this.oEntrada.remitente_enviado.includes(id)) return;
    if(type == 'delegado' && this.oEntrada.delegado.includes(id)) return;
    if(type == 'copia' && this.oEntrada.copia.includes(id)) return;

    let item = this.no_aplica;
    if(id != "NA") {
      item = this.catRemitente.filter((item: any) => { return item.id === id })[0];
    }
    switch (type) {
      case 'enviado_a':
        this.oEntrada.remitente_enviado.push(id);
        this.lista_enviado_a.push(item);
        this.formEntrada.get('remitente_enviado')?.updateValueAndValidity();
      break;
      case 'delegado':
        this.oEntrada.delegado.push(id);
        this.lista_delegado.push(item);
        this.formEntrada.get('remitente_enviado')?.updateValueAndValidity();
        //this.formEntrada.get('delegado')?.updateValueAndValidity();
      break;
      case 'copia':
        this.oEntrada.copia.push(id);
        this.lista_copia.push(item);
      break;
    }

    this.actualizarLista();
  }

  removeList(type: string, id: string): void {
    switch (type) {
      case 'enviado_a': 
        this.oEntrada!.remitente_enviado = this.oEntrada!.remitente_enviado.filter(item => item !== id);
        this.lista_enviado_a = this.lista_enviado_a.filter((item: any) => item.id !== id);
        this.formEntrada.get('remitente_enviado')?.updateValueAndValidity();
      break;
      case 'delegado': 
        this.oEntrada!.delegado = this.oEntrada!.delegado.filter(item => item !== id);
        this.lista_delegado = this.lista_delegado.filter((item: any) => item.id !== id);
        this.formEntrada.get('remitente_enviado')?.updateValueAndValidity();
      break;
      case 'copia': 
        this.oEntrada!.copia = this.oEntrada!.copia.filter(item => item !== id);
        this.lista_copia = this.lista_copia.filter((item: any) => item.id !== id);
      break;
    }

    this.actualizarLista();
  }

  validateTipo (control: FormControl){
    if(control.value === '') {
      return { required:true };
    }
    if(control.value && this.catTipo.filter((item:any) => item.id == control.value && item.activo).length == 0){
      return { required:true };
    }
    return null;
  }

  validateModoEntrada (control: FormControl){
    if(control.value === '') {
      return { required:true };
    }
    if(control.value && this.catModoEntrada.filter((item:any) => item.id == control.value && item.activo).length == 0){
      return { required:true };
    }
    return null;
  }

  validatePrioridad (control: FormControl){
    if(control.value === '') {
      return { required:true };
    }
    if(control.value && this.catPrioridad.filter((item:any) => item.id == control.value && item.activo).length == 0){
      return { required:true };
    }
    return null;
  }

  validateEmpresa (control: FormControl){
    if(control.value === '') {
      return { required:true };
    }
    if(control.value && control.value !== 'otro' && this.catEmpresa.filter((item:any) => item.id == control.value && item.activo).length == 0){
      return { required:true };
    }
    return null;
  }

  validateEnviadoA (control: FormControl) {
    if(this.lista_enviado_a.length == 0)
      return { error_enviado_a : true }
    return null
  }

  validateDelegado (control: FormControl) {
    if(this.lista_delegado.length == 0)
      return { error_enviado_a : true }
    return null
  }

  validateEnvidadoDelegado (control: FormControl) {
    if(this.lista_enviado_a.length == 0 && this.lista_delegado.length == 0)
      return { error_enviado_delegado : true }
    return null
  }

  validateCopia (control: FormControl) {
    if(this.lista_copia.length == 0)
      return { error_copia : true }
    return null
  }

  actualizarLista () {
    let remitente_enviado = this.lista_enviado_a.map(item => item.id);
    let remitente_enviado_correo = this.lista_enviado_a.map(item => item.mail).join(' | ');
    let remitente_enviado_descripcion = this.lista_enviado_a.map(item => `${item.nombre} ${item.apellido} | ${item.mail}`).join(' | ');

    let delegado = this.lista_delegado.map(item => item.id);
    let delegado_correo = this.lista_delegado.map(item => item.mail).join(' | ');
    let delegado_descripcion = this.lista_delegado.map(item => `${item.nombre} ${item.apellido} | ${item.mail}`).join(' | ');

    let copia = this.lista_copia.map(item => item.id);
    let copia_correo = this.lista_copia.map(item => item.mail).join(' | ');
    let copia_descripcion = this.lista_copia.map(item => `${item.nombre} ${item.apellido} | ${item.mail}`).join(' | ');

    this.store.dispatch(cargaEntradaCampos({ oData: {
      'remitente_enviado': remitente_enviado,
      'remitente_enviado_correo': remitente_enviado_correo,
      'remitente_enviado_descripcion': remitente_enviado_descripcion,
      'delegado': delegado,
      'delegado_correo': delegado_correo,
      'delegado_descripcion': delegado_descripcion,
      'copia': copia,
      'copia_correo': copia_correo,
      'copia_descripcion': copia_descripcion
    }}));

    this.disabledDelegadoCopy();
  }

  ngOnDestroy (): void {
    this.editor.destroy();
    this.subscriptions.unsubscribe();
    this.hideRemitente();
  }

  addRemitente () {
    this.store.dispatch(showHideCatalogo({tipoCatalogo: "remitentes", mostrarEditar: false, mostrarNuevo: true, guardando: false}));
  }

  hideRemitente () {
    this.store.dispatch(showHideCatalogo({tipoCatalogo: "remitentes", mostrarEditar: false, mostrarNuevo: false, guardando: false}));
  }

  newRemitente (event: any) {
    this.loadingService.show();
    this.subscriptions.add(
      this.remitenteService.cargarRemitentes().subscribe({
        next: (catRemitente) => {
          this.catRemitente = catRemitente;
          this.store.dispatch(cargaRemitente({ 'catRemitente': catRemitente }));
          this.loadingService.hide();
          //this.formEntrada.get('remitente')?.setValue(event.id);
        },
        error: (error) => {
          this.loadingService.hide();
          this.alertaService.open("Ups", "Error al cargar remitentes:");
        }
      })
    );
  }

  fnRemitenteEliminado(id:string) {
    return {
      id: id,
      activo: false,
      nombre: "Usuario",
      apellido: "Eliminado",
      mail: "...",
      mostrar: false   
    }
  }
}